// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/modules/_defined.js
// module id = iw5+
// module chunks = 1